module.exports = __webpack_public_path__ + "static/mobile-moments-away-btn-17794d420d45c316bf2c5ced4cc8281b.png";